import type React from 'react';

export interface ActionMenuIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const ActionMenuIcon: React.FC<ActionMenuIconProps> = ({
	width = 16,
	height = 17,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Bars Filled Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 16 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<path
			d="M0 2.32967C0 1.04303 1.04303 0 2.32967 0H12.8132C14.0998 0 15.1429 1.04303 15.1429 2.32967H0Z"
			fill="currentColor"
		/>
		<path
			d="M0 11.6484C0 10.3618 1.04303 9.31873 2.32967 9.31873H12.8132C14.0998 9.31873 15.1429 10.3618 15.1429 11.6484H0Z"
			fill="currentColor"
		/>
		<path
			d="M0 4.6593H15.1429C15.1429 5.94594 14.0998 6.98897 12.8132 6.98897H2.32967C1.04303 6.98897 0 5.94594 0 4.6593Z"
			fill="currentColor"
		/>
		<path
			d="M0 13.978H15.1429C15.1429 15.2647 14.0998 16.3077 12.8132 16.3077H2.32967C1.04303 16.3077 0 15.2647 0 13.978Z"
			fill="currentColor"
		/>
	</svg>
);

export default ActionMenuIcon;
